import type { Transition } from 'motion/react';

export const filterOptionLabelClass =
  'font-[Inter] text-[12px] font-medium leading-[170%] text-foreground';

/**
 * Shared layoutId so an email card morphs between the Inbox and Selected
 * sections instead of popping out of one list and into the other.
 */
export const emailItemLayoutId = (id: string) => `email-context-item-${id}`;

/** Position morphs keep delay 0 so entrance staggers never hold up layout shifts. */
export const emailItemTransition: Transition = {
  duration: 0.2,
  ease: 'easeOut',
  layout: { delay: 0, duration: 0.25, ease: [0.4, 0, 0.2, 1] },
};
